import React from 'react';

import './AccountLayout.less';

export type IAccountLayoutProps = {
  children?: React.ReactNode;
}

export function AccountLayout(props: IAccountLayoutProps) {
  return (
    <div className="account-layout">
      {props.children}
    </div>
  );
}
